export default "__VITE_PUBLIC_ASSET__db3b93bd__"